var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-container"},[_c('div',[_c('home-hero'),_c('tests-body',{attrs:{"id":"test-body"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }